import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  CircularProgress,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import MakerPlanTable from "./MakerPlanTable";
import MakerPlanModal from "./MakerPlanModal";
import AddModuleModal from "./AddModuleModal";
import { getAllMakerPlanDetails, getAllMakerPlans } from "../../../services/adminServices/MakerPlanServices";
import { toast } from "react-toastify";

const MakerPlan = () => {
  const [isMakerPlanModalOpen, setIsMakerPlanModalOpen] = useState(false);
  const [isAddModuleModalOpen, setIsAddModuleModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [tableData, setTableData] = useState([]);
  const [makerPlanOptions, setMakerPlanOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingPlans, setIsFetchingPlans] = useState(false);
  const [selectedModule, setSelectedModule] = useState(null);
  const [makerPlanDetails, setMakerPlanDetails] = useState(null); 

  const fetchMakerPlans = async () => {
    setIsFetchingPlans(true);
    try {
      const response = await getAllMakerPlans();
      const plans = response?.data.data || [];
      setMakerPlanOptions(plans);
    } catch (error) {
      toast.error( error?.response?.data.message||error?.message ||error?.error);
    } finally {
      setIsFetchingPlans(false);
    }
  };
  useEffect(() => {
    fetchMakerPlans();
  }, []);

  const fetchData = useCallback(async (planId) => {
    setIsLoading(true);
    try {
      const response = await getAllMakerPlanDetails(planId);
      const planDetails = response?.data.data || {};
      setMakerPlanDetails(planDetails);
      setTableData(planDetails.Maker_Modules);
    } catch (error) {
      toast.error( error?.response?.data.message||error?.message ||error?.error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const toggleMakerPlanModal = () => setIsMakerPlanModalOpen((prev) => !prev);
  const toggleAddModuleModal = () => {
    setIsAddModuleModalOpen((prev) => !prev)
    isAddModuleModalOpen && handleEditComplete();
  };
  const handleEditComplete = () => {
    setSelectedModule(null);
  };
  const handleSelectionChange = (event) => {
    const { value } = event.target;
    setSelectedPlan(value);
    if (value) fetchData(value);
  };

  const handleEditModule = (moduleData) => {
    setSelectedModule(moduleData);
    toggleAddModuleModal();
  };

  return (
    <Box className="dashboard-container">
      <Box className="DailyPractice-header" sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "space-between", gap: 4, position: "relative" }}>
        <Box className="daily-practice-inputs" gap={2} display="flex" alignItems="center">
          <FormControl fullWidth>
            <InputLabel id="maker-plan-label">Maker Plan</InputLabel>
            <Select
              labelId="maker-plan-label"
              id="maker-plan-select"
              value={selectedPlan}
              onChange={handleSelectionChange}
              label="Maker Plan"
              disabled={isFetchingPlans}
            >
              {isFetchingPlans ? (
                <MenuItem disabled>
                  <CircularProgress size={24} />
                </MenuItem>
              ) : (
                makerPlanOptions.map((option, index) => (
                  <MenuItem key={index} value={option.makerplanID}>
                    {option.makerplan_Name}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
          <IconButton onClick={toggleMakerPlanModal} title="Create Maker Plan">
            <AddCircleOutlineIcon fontSize="large" />
          </IconButton>
        </Box>

        {selectedPlan !== "" && makerPlanDetails && (
          <>
            <Typography marginBottom={5} width="100%" fontSize="18px" fontWeight="500">
              The <strong>{makerPlanDetails.makerplan_Name}</strong> Maker Plan is designed for <strong>{makerPlanDetails.coding_Hrs}</strong> hours of intensive coding practice.
            </Typography>
            <Box display="flex" alignItems="center" gap={2} position="absolute" bottom={0} right={0}>
              <Button
                variant="contained"
                color="primary"
                onClick={toggleAddModuleModal}
                className="dashboard-header-button"
              >
                Add Module
              </Button>
            </Box>
          </>
        )}

        <MakerPlanModal open={isMakerPlanModalOpen} onClose={toggleMakerPlanModal} fetchMakerPlans={fetchMakerPlans} />
        <AddModuleModal open={isAddModuleModalOpen} onClose={toggleAddModuleModal} moduleData={selectedModule} selectedPlan={selectedPlan} onEditComplete={handleEditComplete} fetchData={fetchData} />
      </Box>

      <Box className="dashboard-box-container">
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        ) : tableData.length > 0 &&
        <MakerPlanTable rows={tableData} onEdit={handleEditModule}fetchData={fetchData} selectedPlan={selectedPlan} />
        }
      </Box>
    </Box>
  );
};

export default MakerPlan;
